/**
 * Everything is free (Tornike, 2026-11-01). 981 sign-ups brought one $5
 * payment: the free week ran on empty cards and the one payer turned the
 * renewal off a minute later. So every lesson, phrases lesson and test is
 * open to everyone, and Pro, prices and the coin discount are hidden.
 *
 * The payment code stays as it is. To bring the paywall back: build with
 * VITE_PAYWALL=on AND put the Pro check back into complete_exam_task /
 * save_exam_result (migration 0027 removed it — 0026 has the old bodies).
 * The paywall e2e suites run against a VITE_PAYWALL=on server, so that code
 * keeps working while it sleeps.
 *
 * 2026-11-01 evening: Tornike brought the paid version back. Production
 * builds set VITE_PAYWALL=on (apps/app/.env.production) and migration 0028
 * restored the server's Pro check; the switch stays for the next time.
 */
export const EVERYTHING_FREE: boolean =
  (import.meta.env.VITE_PAYWALL as string | undefined) !== 'on';
